import React, { type ReactNode } from 'react';
import { styled } from '@compiled/react';
import { Box, xcss } from '@atlaskit/primitives';
import { colors } from '@atlaskit/theme';
import { token } from '@atlaskit/tokens';
import { fg } from '@atlassian/jira-feature-gating';

// Simulates parent div from project create window
// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const FullHeightWrapper = styled.div({
	display: 'flex',
	minHeight: '95vh',
	height: '100%',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.accent.gray.subtlest', colors.N20),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const LearnMore = styled.a({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.accent.blue', colors.B400),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const PageHeadingOld = styled.h1({
	fontSize: '29px',
	fontWeight: 500,
	lineHeight: '32px',
	marginTop: token('space.1000', '80px'),
	marginBottom: token('space.300', '24px'),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const SectionHeading = styled.h1({
	display: 'block',
	fontWeight: '500',
	fontSize: '20px',
	lineHeight: '24px',
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtle', colors.N700),
});

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- Ignored via go/DSP-18766
const PageDescriptionOld = styled.p({
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	color: token('color.text.subtlest', colors.N400),
	marginTop: '0px',
	marginBottom: token('space.200', '16px'),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ErrorHeading = styled.h2({
	fontSize: '20px',
	fontWeight: 500,
	lineHeight: '24px',
	marginTop: token('space.400', '40px'),
	marginBottom: token('space.200', '16px'),
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropdownSectionWrapper = styled.div({
	margin: `${token('space.200', '16px')} ${token('space.200', '16px')} ${token(
		'space.150',
		'12px',
	)} ${token('space.200', '16px')}`,
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropdownSectionHeader = styled.h3({
	textTransform: 'uppercase',
	fontSize: '12px',
	lineHeight: '16px',
});

// eslint-disable-next-line jira/styled/no-styled-export, @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const DropdownSectionDivider = styled.div({
	height: token('space.025', '2px'),
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-imported-style-values -- Ignored via go/DSP-18766
	backgroundColor: token('color.background.accent.gray.subtlest', colors.N30),
	borderRadius: '1px',
	marginBottom: token('space.100', '8px'),
});

export const PageHeading = ({ children }: { children: ReactNode }) =>
	fg('enable-x2c-standardised-flow') ? (
		<Box as="h1" xcss={headerStyles}>
			{children}
		</Box>
	) : (
		<PageHeadingOld>{children}</PageHeadingOld>
	);

export const PageDescription = ({ children, testId }: { children: ReactNode; testId?: string }) =>
	fg('enable-x2c-standardised-flow') ? (
		<Box xcss={descriptionStyles} testId={testId}>
			{children}
		</Box>
	) : (
		<PageDescriptionOld data-testId={testId}>{children}</PageDescriptionOld>
	);

const headerStyles = xcss({
	color: 'color.text',
	font: token('font.heading.large'),
	paddingBottom: 'space.100',
});

const descriptionStyles = xcss({
	color: 'color.text.subtle',
	font: token('font.body'),
	paddingBottom: 'space.200',
});
